import Vue from 'vue';
import Vuex from 'vuex';
import stocks from '@/store/stocks';

export default () => {
  Vue.use(Vuex);

  return new Vuex.Store({
    state: {
    },
    modules: {
      stocks,
    },
  });
};
